import { DragEvent, useState } from 'react';
import styled from 'styled-components';
import { FlexCol } from './Flex';
import { Text } from './Text';
import { Icon } from './Icon';
import IconUpload from '../../../public/icons/upload.svg?react';

const StyledInputContainer = styled(FlexCol)<{ $dropActive: boolean; $disabled: boolean }>`
	opacity: ${({ $disabled }) => ($disabled ? 0.4 : 1)};
	padding: 20px 30px;
	text-align: center;
	position: relative;
	overflow: hidden;
	cursor: ${({ $disabled }) => ($disabled ? 'not-allowed' : 'default')};

	border: 1px solid ${({ theme, $dropActive }) => ($dropActive ? theme.input_border_active : theme.input_border)};
	background: ${({ theme }) => theme.input_bg};
	border-radius: 4px;
	transition:
		border-color 0.2s,
		background 0.2s ease-out;
	&:hover {
		border-color: ${({ theme, $disabled }) => ($disabled ? theme.input_border : theme.input_border_active)};
	}
`;

const StyledInputFileButton = styled.input`
	position: absolute;
	top: 0;
	bottom: 0;
	left: 0;
	right: 0;
	opacity: 0;
	cursor: pointer;

	background-color: transparent;
	border: none;

	&:disabled {
		cursor: not-allowed;
	}
	&:hover:enabled {
		transform: scale(1.02);
	}
	&:active:enabled {
		transform: scale(0.98);
	}
`;

export function File(props: {
	typeText: string;
	fileTypes: string[];
	fileSelected?: string;
	error?: string;
	onFileDrop: (value: FileList | null) => void;
	disabled?: boolean;
}) {
	const { typeText, fileSelected, error, onFileDrop, disabled } = props;

	const [dropActive, setDropActive] = useState(false);

	const onDragEnter = (e: DragEvent<HTMLDivElement>) => {
		e.preventDefault();
		setDropActive(true);
	};

	const onDragLeave = (e: DragEvent<HTMLDivElement>) => {
		e.preventDefault();
		setDropActive(false);
	};

	const onDrop = (e: DragEvent<HTMLDivElement>) => {
		if (disabled) return;
		e.preventDefault();
		setDropActive(false);
		onFileDrop(e.dataTransfer.files);
	};
	const onDragOver = (e: DragEvent<HTMLDivElement>) => {
		e.preventDefault();
		e.stopPropagation();
	};

	return (
		<StyledInputContainer $dropActive={dropActive} $disabled={disabled ?? false}>
			<StyledInputFileButton
				type="file"
				onChange={(v) => onFileDrop(v.target.files)}
				accept={props.fileTypes.join(',')}
				disabled={disabled}
				onDragOver={onDragOver}
				onDragEnter={onDragEnter}
				onDragLeave={onDragLeave}
				onDrop={onDrop}
			/>
			<Icon $colorFill="file_fg" style={{ height: '2rem', margin: '0 auto 1.5rem auto' }}>
				<IconUpload />
			</Icon>
			<Text
				$color="file_fg"
				$size="1.3rem"
				$weight="400"
				style={{ marginBottom: '1rem', overflow: 'hidden', textOverflow: 'ellipsis' }}
			>
				{fileSelected ? (
					`${fileSelected} selected.`
				) : (
					<>
						Click to Upload or
						<br />
						Drag and Drop
					</>
				)}
			</Text>
			<Text $color="file_alt_fg" $size="1.3rem" $weight="400">
				{typeText}
			</Text>
			{error && (
				<Text $color="text_red" $size="1.2rem" $weight="500" style={{ marginTop: 15 }}>
					{error}
				</Text>
			)}
		</StyledInputContainer>
	);
}
